<template>
    <q-page padding>
        <q-tabs class="shadow-1 q-mt-md" color="secondary" v-model="tab">
            <q-tab slot="title" v-for="(l, index) in layouts" :name="`l${l.id}`" :label="l.slug"  :key="`t${index}`" />

            <q-tab-pane v-for="(l, index) in layouts" :name="`l${l.id}`" :key="`p${index}`">
                <div class="row gutter-md">
                    <div class="col-6">
                        <q-card class="full-height">
                            <q-card-title>
                                {{ $t('included_modules') }}
                            </q-card-title>

                            <q-card-separator />

                            <q-card-main>
                                <draggable :list="l.items" :group="`l${l.slug}`">
                                    <q-card v-for="(e, index) in l.items" :key="e.slug" class="cursor-pointer q-mb-md">
                                        <q-card-main>
                                            {{ e.slug }}
                                        </q-card-main>
                                    </q-card>
                                </draggable>
                            </q-card-main>
                        </q-card>
                    </div>

                    <div class="col-6">
                        <q-card class="full-height">
                            <q-card-title>
                                {{ $t('avaliable_modules') }}
                            </q-card-title>

                            <q-card-separator />

                            <q-card-main>
                                <draggable :list="l.items_out" :group="`l${l.slug}`">
                                    <q-card v-for="(e, index) in l.items_out" :key="e.slug" class="cursor-pointer q-mb-md">
                                        <q-card-main>
                                            {{ e.slug }}
                                        </q-card-main>
                                    </q-card>
                                </draggable>
                            </q-card-main>
                        </q-card>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'admin_overview' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveConfig()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
    name: 'AdminHomeModules',
    
    i18nOptions: { namespaces: ['common', 'admin'] },

    data() {
        return {
            tab: '',
            layouts: []
        }
    },

    components: {
        draggable,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.get('/clients/config_layouts/', this.getHeader)
	        .then(response => {
                this.layouts = response.data
                this.tab = `l${response.data[0].id}`
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveConfig() {
            let selected_id = this.tab.slice(1)
            let obj = this.layouts.find((obj) => { return obj.id == selected_id })
            if (obj) {
                this.$q.loading.show()

                let data = {
                    items: obj.items.map(e => { return { slug: e.slug } }),
                    items_out: obj.items_out.map(e => { return { slug: e.slug } })
                }

                this.$axios.put(`/clients/config_layouts/${selected_id}/`, data, this.getHeader)
                .then(() => {
                    this.$q.notify({
                        message: this.$t('basic_data_save_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })
                .catch(e => {
                    console.log(e)
                    this.$q.notify({
                        message: this.$t('basic_data_save_error'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
    },

    created() {
        this.fetchAll()
    }
}
</script>

<style>

</style>